import React from 'react'
import { Copy } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useToast } from '@/components/ui/use-toast'
import { cn } from '@/lib/utils'

interface UrlWithCopyProps {
  url: string
  className?: string
}

export function UrlWithCopy({ url, className }: UrlWithCopyProps) {
  const { toast } = useToast()

  const handleCopy = async (event: React.MouseEvent) => {
    event.preventDefault()
    event.stopPropagation()

    try {
      await navigator.clipboard.writeText(url)
      toast({
        title: '已复制',
        description: url,
      })
    } catch {
      toast({
        variant: 'destructive',
        title: '复制失败',
        description: '无法复制到剪贴板',
      })
    }
  }

  return (
    <div className={cn('inline-flex max-w-xs items-center gap-1', className)}>
      <a
        href={url}
        target="_blank"
        rel="noreferrer"
        className="min-w-0 flex-1 truncate text-xs leading-4 text-blue-600 hover:underline"
      >
        {url}
      </a>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="h-4 w-4 shrink-0 p-0 text-muted-foreground hover:text-foreground"
        onClick={handleCopy}
        title="复制链接"
      >
        <Copy className="h-3.5 w-3.5" />
      </Button>
    </div>
  )
}
